import { CLICK, POPUP, component, demoFile, story, feature } from 'system/demo';
import { ManageChannelsScreen } from 'open-modules/zdf/feature/admin/admin-manage-channels';
import { makeAssetUrl } from 'util/util';

const demoAdminEmails = ['a@b.com', 'c@d.com', 'test@test.com'];

const demoChannel0 = {
    channel0: {
        from: 'a',
        isDefault: true,
        key: 'channel0',
        name: 'Default Channel',
        photoUrl: makeAssetUrl('/faces/robo.jpeg'),
    },
};
const demoChannel1 = {
    channel1: {
        from: 'a',
        isDefault: false,
        key: 'channel1',
        name: 'Channel 1',
        photoUrl: makeAssetUrl('/faces/robo.jpeg'),
    },
};

const channelFullDemoData = {
    channelMembers: {
        [demoChannel0.channel0.key]: { memberEmails: [demoAdminEmails[0], demoAdminEmails[1]] },
        [demoChannel1.channel1.key]: { memberEmails: [] },
    },
    modulePublic: {
        channel: {
            all: { ...demoChannel0, ...demoChannel1 },
            instanceToChannel: {},
        },
    },
    serverCall: {
        admin: {
            getAdminUsers: async () => [
                { key: 'admin0', roles: ['Moderator'], email: demoAdminEmails[0] },
                { key: 'admin1', roles: ['Moderator'], email: demoAdminEmails[1] },
                { key: 'admin2', roles: ['Moderator'], email: demoAdminEmails[2] },
            ],
        },
        channel: {
            getChannelMembers: async ({ channelKey }) => Promise.resolve(channelFullDemoData.channelMembers[channelKey]),
            addMemberByEmail: async ({ email, channelKey }) => {
                channelFullDemoData.channelMembers[channelKey].memberEmails.push(email);
                return Promise.resolve();
            },
            removeMemberFromChannel: async ({ email, channelKey }) => {
                const updated = channelFullDemoData.channelMembers[channelKey].memberEmails.filter((u) => u !== email);
                channelFullDemoData.channelMembers[channelKey].memberEmails = updated;
                return Promise.resolve();
            },
            createChannel: async () => Promise.resolve(),
            updateChannel: async () => Promise.resolve(),
        },
    },
};

const channelManagementDemoData = {
    channelMembers: {
        [demoChannel0.channel0.key]: { memberEmails: [demoAdminEmails[0], demoAdminEmails[1]] },
        [demoChannel1.channel1.key]: { memberEmails: [] },
    },
    modulePublic: {
        channel: {
            all: { ...demoChannel0, ...demoChannel1 },
            instanceToChannel: {},
        },
    },
    serverCall: {
        admin: {
            getAdminUsers: async () => [
                { key: 'admin0', roles: ['Moderator'], email: demoAdminEmails[0] },
                { key: 'admin1', roles: ['Moderator'], email: demoAdminEmails[1] },
                { key: 'admin2', roles: ['Moderator'], email: demoAdminEmails[2] },
            ],
        },
        channel: {
            getChannelMembers: async ({ datastore, channelKey }) => {
                const channels = datastore.getSessionData(['channelMembers']);
                return Promise.resolve(channels[channelKey]);
            },
            addMemberByEmail: async ({ email, channelKey, datastore }) => {
                const channels = datastore.getSessionData(['channelMembers']);
                channels[channelKey].memberEmails.push(email);
                datastore.setSessionData(['channelMembers'], channels);
                return Promise.resolve();
            },
            removeMemberFromChannel: async ({ datastore, email, channelKey }) => {
                const channels = datastore.getSessionData(['channelMembers']);
                const updated = channels[channelKey].memberEmails.filter((u) => u !== email);
                channels[channelKey].memberEmails = updated;
                datastore.setSessionData(['channelMembers'], channels);
                return Promise.resolve();
            },
        },
    },
};

demoFile('open-modules/zdf/feature/admin/manage-channels');

component('ManageChannelsScreen', ManageChannelsScreen, {
    structureKey: 'admin',
    instanceKey: 'a',
    state: {
        serverCall: channelManagementDemoData.serverCall,
        modulePublic: channelManagementDemoData.modulePublic,
        sessionData: { channelMembers: channelManagementDemoData.channelMembers },
        roles: ['Owner'],
    }
}, [
    story('Delete user from channel', [
        CLICK('selectable-tile-' + channelManagementDemoData.modulePublic.channel.all.channel0.key),
        CLICK('delete-member-' + channelManagementDemoData.channelMembers.channel0.memberEmails[0]),
    ]),
    story('Add user to channel', [
        CLICK('selectable-tile-' + channelManagementDemoData.modulePublic.channel.all.channel1.key),
        CLICK('add-member-dropdown'),
        POPUP(CLICK(demoAdminEmails[2])),
        CLICK('Add Moderator'),
    ])
]);

feature('adminmanagechannels', {
    structureKey: 'admin',
    features: { adminmanagechannels: true, channelbase: true },
    state: {
        serverCall: channelFullDemoData.serverCall,
        modulePublic: channelFullDemoData.modulePublic,
    }
});
